module.exports = __webpack_public_path__ + "static/media/Login_Default.8d17b815.jpg";